import { RemoveRedEyeOutlined } from '@mui/icons-material';
import { Box, Button, Stack, TextField, Typography } from '@mui/material';
import { Field, Form, Formik, FormikProvider, useFormik } from 'formik';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import GlobalViewAttachment from '../../../../components/Fileupload/GlobalViewAttachment';
import GlobalFileUploadComponent from '../../../../components/Fileupload/GlobalFileUploadComponent';
import { useDispatch } from 'react-redux';
import useHandleApiResponse from '../../../../Hooks/useHandleApiResponse';
import { putBankDetails } from '../../../../redux/features/refundSlice';
import { useSelector } from 'react-redux';
import NoDataFound from '../../../../components/NodataIndication/NoDataFound';
import { useEffect } from 'react';
import GlobalAllTypeFileUpload from '../../../../components/Fileupload/GlobalAllTypeFileUpload';
import GlobalAllTypeFileView from '../../../../components/Fileupload/GlobalAllTypeFileView';

// reason=1-'Incorrect Bank Account Details',2-'Insufficient Proof',3-'Incorrect Amount'
export default function ReasonEdit({ setOpen, reason, rowData, non, dispatchParams, submitDispatch, open }) {
  const REASONS = [1, 2, 3];
  const { submitionLoading } = useSelector((state) => state.refund);
  const Mapper = [
    { label: 'Account Holder Name', value: rowData?.refund_ac_holder || '', name: 'refund_ac_holder' },
    { label: 'Account Number', value: rowData?.refund_ac_no || '', name: 'refund_ac_no' },
    { label: 'IFSC Code', value: rowData?.refund_ifsc || '', name: 'refund_ifsc' },
  ];

  const AmountFlag = reason == 3;
  const AttachmentFlag = reason == 2;
  const BankAccDetailsFlag = reason == 1;

  const initialValues = {
    holdamount_refund_id: rowData?.holdamount_refund_id || null,
    expense_id: rowData?.expense_id || null,
    ...(BankAccDetailsFlag
      ? {
          refund_ac_holder: rowData?.refund_ac_holder || '',
          refund_ac_no: rowData?.refund_ac_no || '',
          refund_ifsc: rowData?.refund_ifsc || '',
        }
      : {}),
    ...(AttachmentFlag
      ? {
          attachmentUrl: '',
          attachmentUrlDisplay: '',
          ...(non ? { parent_connection_attachmentUrl: '', parentAttachmentDisplay: '' } : {}),
        }
      : {}),
    ...(AmountFlag ? (non ? { holdamount_refund_amount: '' } : { expense_amount: '' }) : {}),
  };

  const dispatch = useDispatch();
  const handleResponseApi = useHandleApiResponse();
  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    onSubmit: (v) =>
      dispatch(
        putBankDetails({
          ...v,
          attachmentUrl: v?.attachmentUrl || rowData?.attachmentUrl,
          ...(!non
            ? {
                parent_connection_attachmentUrl:
                  v?.parent_connection_attachmentUrl || rowData?.parent_connection_attachmentUrl,
              }
            : []),
        }),
      ).then((res) =>
        handleResponseApi(res, {
          onSuccess: () => {
            setOpen(false);
            dispatch(submitDispatch(dispatchParams));
          },
        }),
      ),
  });

  //clear the formik
  useEffect(() => {
    formik.resetForm();
  }, [open]);

  if (!REASONS.includes(reason)) return <NoDataFound />;
  return (
    <Box
      flexDirection={'column'}
      sx={{
        minWidth: { xs: '100%', md: 500 },
        maxWidth: '100%',
      }}
      display={'flex'}
      gap={2}
    >
      {/* Bank Account Detials */}
      {BankAccDetailsFlag && (
        <Box display={'flex'} flexDirection={'column'} gap={1} bgcolor={'ButtonHighlight'} p={2} borderRadius={1}>
          {Mapper.map(({ label, value }, i) => (
            <Box display={'flex'} gap={1} justifyContent={'space-between'} key={i}>
              <Typography variant="body1" fontWeight={500}>{`${label} :`}</Typography>
              <Typography>{value}</Typography>
            </Box>
          ))}
        </Box>
      )}
      {/* Attachments */}
      {AttachmentFlag && (
        <Box display={'flex'} flexDirection={'column'} gap={2}>
          {!non && (
            <Box
              display={'flex'}
              justifyContent={'space-between'}
              border={'1px solid #108FBA'}
              borderRadius={1}
              p={2}
              alignItems={'center'}
              fontWeight={600}
            >
              <Typography>Refund Request Date Attachment : </Typography>
              {/* <GlobalViewAttachment
                attachmentFileName={rowData?.parent_connection_attachmentUrl}
                previewButtonName={'View'}
              /> */}
              <GlobalAllTypeFileView
                attachmentFiles={rowData?.parent_connection_attachmentUrl}
                previewButtonName={'View'}
              />
            </Box>
          )}
          <Box
            display={'flex'}
            justifyContent={'space-between'}
            border={'1px solid #108FBA'}
            borderRadius={1}
            p={2}
            alignItems={'center'}
            fontWeight={600}
          >
            <Typography>Refund Request Attachment : </Typography>
            {/* <GlobalViewAttachment attachmentFileName={rowData?.attachmentUrl} previewButtonName={'View'} /> */}
            <GlobalAllTypeFileView attachmentFiles={rowData?.attachmentUrl} previewButtonName={'View'} />
          </Box>
        </Box>
      )}
      {/* Amount */}
      {AmountFlag && (
        <Box display={'flex'} flexDirection={'column'} gap={1} bgcolor={'ButtonHighlight'} p={2} borderRadius={1}>
          <Box display={'flex'} gap={1} justifyContent={'space-between'}>
            <Typography variant="body1" fontWeight={500}>
              Amount :
            </Typography>
            <Typography>{non ? rowData?.holdamount_refund_amount : rowData?.expense_amount}</Typography>
          </Box>
        </Box>
      )}
      <FormikProvider value={formik}>
        <Form>
          <Box>
            <Typography variant="h5" my={3}>
              New
            </Typography>

            <Box display={'flex'} flexDirection={'column'} gap={2}>
              {/* Bank Account Detials */}
              {BankAccDetailsFlag && (
                <Stack gap={1}>
                  {Mapper.map(({ label, name }, i) => (
                    <Field as={TextField} label={label} name={name} key={i} />
                  ))}
                </Stack>
              )}
              {/* Attachments */}
              {AttachmentFlag && (
                <Box display={'flex'} flexDirection={'column'} alignItems={'center'} gap={2}>
                  {/* {!non && (
                    <GlobalFileUploadComponent
                      formik={formik}
                      fileDisplayName="parent_connection_attachmentUrlDisplay"
                      fileBackendLink="parent_connection_attachmentUrl"
                      accept=".pdf,image/*"
                      label="Parent Attachment"
                    />
                  )} */}
                  {!non && (
                    <GlobalAllTypeFileUpload
                      formik={formik}
                      formikNameArray="parent_connection_attachmentUrl"
                      // accept="image/*,video/*,audio/*,application/pdf"
                      accept="image/*"
                      dbFolderName="refund"
                      label="Refund Request Date"
                      multiple
                    />
                  )}
                  {/*  <GlobalFileUploadComponent
                    formik={formik}
                    fileDisplayName="attachmentUrlDisplay"
                    fileBackendLink="attachmentUrl"
                    accept=".pdf,image/*"
                    label="Refund Attachment"
                  /> */}
                  {/* <GlobalAllTypeFileUpload
                    formik={formik}
                    formikNameArray="attachmentUrl"
                    accept="image/*,video/*,audio/*,application/pdf"
                    dbFolderName="refund"
                    label="Refund Attachment"
                  /> */}
                  <GlobalAllTypeFileUpload
                    formik={formik}
                    formikNameArray="attachmentUrl"
                    accept="image/*,video/*,audio/*,application/pdf"
                    dbFolderName="refund"
                    label="Refund Request Attachment"
                    multiple
                  />
                </Box>
              )}
              {/* Amount */}
              {AmountFlag && (
                <Box>
                  <Field
                    as={TextField}
                    label={'Amount'}
                    name={non ? 'holdamount_refund_amount' : 'expense_amount'}
                    fullWidth
                  />
                </Box>
              )}
              <Box display={'flex'} gap={1} alignSelf={'flex-end'}>
                <Button variant="outlined" onClick={() => setOpen(false)}>
                  Cancel
                </Button>
                <Button variant="contained" type="submit" disabled={submitionLoading}>
                  {submitionLoading ? 'Updating...' : `Update`}
                </Button>
              </Box>
            </Box>
          </Box>
        </Form>
      </FormikProvider>
    </Box>
  );
}
